import React from 'react';
import { colors, typography, radius, spacing, shadows } from '../../../theme';

const formatDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { month: 'short', day: 'numeric' });
};

/**
 * Highlights the most recent PR. Premium but restrained — this is one of the
 * few places a gold glow is warranted (an achieved milestone), not routine.
 */
const LatestPR = ({ latestPR }) => {
  if (!latestPR) return null;

  const { exercise_name, weight, reps, created_at, estimated1RM, increaseKg, increasePercent } = latestPR;
  const hasDelta = typeof increaseKg === 'number' && increaseKg > 0;

  return (
    <div style={styles.card}>
      <div style={{ ...typography.label, color: colors.gold, marginBottom: spacing.sm }}>
        Latest Personal Record
      </div>
      <div style={{ ...typography.sectionHeading, color: colors.text }}>{exercise_name}</div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: spacing.sm, marginTop: spacing.xs }}>
        <span style={{ ...typography.metric, fontSize: '28px', color: colors.text }}>
          {estimated1RM ?? weight} kg
        </span>
        <span style={{ ...typography.caption, color: colors.textMuted }}>
          {estimated1RM ? 'estimated 1RM' : `${reps} reps`}
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md, marginTop: spacing.sm }}>
        {hasDelta && (
          <span style={{ ...typography.caption, color: colors.success, fontWeight: '700' }}>
            ↑ {increaseKg} kg{increasePercent ? ` (${increasePercent}%)` : ''}
          </span>
        )}
        <span style={{ ...typography.caption, color: colors.textSubtle }}>{formatDate(created_at)}</span>
      </div>
    </div>
  );
};

const styles = {
  card: {
    padding: spacing.lg,
    background: colors.surface1,
    border: `1px solid ${colors.borderStrong}`,
    borderRadius: radius.card,
    marginBottom: spacing.lg,
    boxShadow: shadows.goldGlow,
  },
};

export default LatestPR;
